import { useEffect, useState, useContext } from "react";
import { Column, Icon, Panel, Row, Button, Select } from "../../components";
import { Container, Badge } from "react-bootstrap";
import React from "react";
import { FaChevronRight, FaChevronDown } from 'react-icons/fa';
import './CustomerDocument.scss';
import * as label from '../../shared/util/label';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomerDocumentService from "./CustomerDocumentService";
import '../customer-policy/policy-summary-header/PolicySummaryHeader.scss';
import insuranceProducts from '../../shared/components/insuranceProductList/InsuranceProductList.json';
import { policyTypeIconMapping } from '../../shared/components/insuranceProductList/InsuranceProductListService';
import { ConfirmModal } from '../../shared/components/confirmModal';
import * as docuMateConstant from '../../DocuMate/shared/util/docuMateConstant';
import * as documateLabel from '../../DocuMate/shared/util/docuMateLabel';
import { UploadCustomerDocument } from "../../DocuMate/services/DocuMateAPI";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Logger from '../../shared/services/Logger';
import DocViewer from '../../../src/DocuMate/shared/components/DocViewer';
import DocuMateScanService from '../../../src/DocuMate/DocuMateScan/DocuMateScanService';
import * as constant from '../../shared/util/constant';
import { AbilityContext } from "../../shared/abilities/AbilityContext";

interface Props {
    customerId: string
}

const CustomerDocument: React.FunctionComponent<Props> = ({ customerId }) => {
    const [docWithPolicies, setDocWithPolicies] = useState([]);
    const [docWithOutPolicies, setDocWithOutPolicies] = useState([]);
    const [expandedTerm, setExpandedTerm] = useState<string | null>(null);
    const customerDocumentService = new CustomerDocumentService();      
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState<string>('');
    const [selectedTerm, setSelectedTerm] = useState<string>('');
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [customerDataPolicies, setCustomerDataPolicies] = useState<any[]>([]);
    const [sampleDocumentType, setSampleDocumentType] = useState([]);
    const [policyArray, setPolicyArray] = useState<any[]>([]);
    const [folderArray, setFolderArray] = useState<any[]>([]);
    const [folderOption, setFolderOption] = useState('');
    const [termArray, setTermArray] = useState<any[]>([]);
    const [documentTypeOption, setDocumentTypeOption] = useState('');
    const [policyOption, setPolicyOption] = useState('');
    const userDetails = useSelector((state: any) => state.userContextSlice);
    const [fileError, setFileError] = useState('');
    const [screenMessage, setScreenMessage] = useState('');
    const [docViewerOpen, setDocViewerOpen] = useState(false);
    const [docId, setDocId] = useState('');
    const [docName, setDocName] = useState('');
    const [uploadCustomerSummary, setUploadCustomerSummary] = useState<any>(null);
    const [docNameAPI, setDocNameAPI] = useState('');
    const [docViewerId, setdocViewerId] = useState('');
    const [docPdf, setDocPDf] = useState<any>(null);
    const documateServiceObj = new DocuMateScanService();
    const customerSummary = useSelector((state: any) => state.customerSlice);
    const ab_subject = "Customer Document";
    const ability = useContext(AbilityContext);
    const isUserPermitToViewUpploadButton = ability.can('view', ab_subject, constant.CustomerDocumentPrivileges.UPLOAD)
    const isUploadDisabledForUserPermission = !ability.can('read', ab_subject, constant.CustomerDocumentPrivileges.UPLOAD);
    const isUserPermitToViewDeleteButton = ability.can('view', ab_subject, constant.CustomerDocumentPrivileges.DELETE)
    const isDeleteDisabledForUserPermission = !ability.can('read', ab_subject, constant.CustomerDocumentPrivileges.DELETE);
    const [expandedFolders, setExpandedFolders] = useState([]);
    const custNumber = customerSummary.customerSummary?.custNumber || uploadCustomerSummary?.custNumber || '';
    const custName = customerSummary.customerSummary?.displayName || uploadCustomerSummary?.displayName || '';
    const toggleFolder = (folderPath: string) => {
        setExpandedFolders((prev) =>
            prev.includes(folderPath) ? prev.filter((path) => path !== folderPath)
                : [...prev, folderPath]
        );
    };    

    const splitFolders = (attributeValue) => {
        if (!attributeValue) return [];
        const parts = attributeValue.split('/Policy').map((part, index) => {
            if (index === 0) return part.trim(); // First part before any 'Policy'
            return `Policy${part.trim() ? ' ' + part.trim() : ''}`; // Add 'Policy' back
        });
        return parts.filter(Boolean);
    };

    const [validation, setValidation] = useState({
        policy: false,
        term: false,
        documentType: false,
        file: false,
        folder: false,
    });
    const isNullOrEmpty = (val: any) =>
        val === null || val === undefined || (typeof val === 'string' && val.trim() === '');


    useEffect(() => {
        setUploadCustomerSummary(null);
        getCustomerPolicyTermDocumentDetails();
    }, [customerId]);

    const getStatusBadgeClass = (status: string) => {
        const normalized = (status || 'Default').replaceAll(' ', '').replaceAll('-', '').toLowerCase();
        return `customerdoc-policy-status-badge customerdoc-policy-status-badge--${normalized}`;
    };

    const handleTermToggle = (termId: string) => {
        setExpandedTerm(expandedTerm === termId ? null : termId);
    };

    const getPolicyIcon = (policyTypeId: string) => {
        if (!policyTypeId) return 'circle-question';
        const iconId = policyTypeIconMapping[policyTypeId];
        const product = insuranceProducts.find((item) => item.id === iconId);
        return product?.icon || 'circle-question';
    };

   
    const getCustomerPolicyTermDocumentDetails = async () => {        
        const customerPolicyTermDocumentDetails = await customerDocumentService.getCustomerPolicyTermDocumentDetails(customerId);
        let CustNumber = '';
        let CustName = '';
        const documentsWithoutPolicyNumber = customerPolicyTermDocumentDetails
            .filter(policy => policy.policyNumber === null)
            .reduce((acc, policy) => {
                policy.documents.forEach(doc => {
                    const folderPath = splitFolders(doc.attributeValue || '');
                    const isOneStep = folderPath.includes(docuMateConstant.NoPolicyFolderName);

                    // Find or create the correct group
                    const type = isOneStep ? docuMateConstant.NoPolicyFolderName : "OTHER";
                    let group = acc.find(p => p.type === type);
                    if (!group) {
                        group = {
                            type,
                            custId: policy.custId,
                            custNumber: policy.custNumber,
                            custName: policy.custName,
                            folders: []
                        };
                        acc.push(group);
                    }
                    addDocumentToNoPolicyNumberGroup(group, folderPath, doc);
                });

                if (acc.length === 0) {
                    CustNumber = policy.custNumber;
                    CustName = policy.custName;
                }
                return acc;
            }, []);

        const documentsWithPolicyNumber = customerPolicyTermDocumentDetails
            .filter(policy => policy.policyNumber !== null)
            .reduce((acc, policy) => {
                let group = acc.find(p => p.policyNumber === policy.policyNumber);
                if (!group) {
                    group = {
                        custId: policy.custId,
                        custNumber: policy.custNumber,
                        custName: policy.custName,
                        policyNumber: policy.policyNumber,
                        policyType: policy.policyType,
                        policyTypeId: policy.policyTypeId,
                        terms: []
                    };
                    acc.push(group);
                }
                group.terms.push({
                    id: policy.policyId,
                    polEffDate: policy.polEffDate,
                    polExpDate: policy.polExpDate,
                    policyStatus: policy.policyTermStatus,
                    calculatedPolTermStatus: policy.calculatedPolTermStatus,
                     isUnknown: policy.documents.some(doc => 
                        (policy.polExpDate || '').trim() !== (doc.attributeValue.split(" to ")[1] || '').trim()
                    ),
                    documents: policy.documents
                });
                if (acc.length === 0) {
                    CustNumber = policy.custNumber;
                    CustName = policy.custName;
                }
                return acc;
            }, []);

        if (documentsWithPolicyNumber.length > 0) {
            setDocWithPolicies(documentsWithPolicyNumber);
        }
        else {
            setDocWithPolicies([]);
        }

        if (documentsWithoutPolicyNumber.length > 0) {
            setDocWithOutPolicies(documentsWithoutPolicyNumber);
        }
        else {
            setDocWithOutPolicies([]);
        }

        if (documentsWithoutPolicyNumber.length == 0 && documentsWithPolicyNumber.length == 0) {
            setScreenMessage('Documents are not available for this customer.');
        }
      // Call the function to sort the array
       sortDocumentsWithPolicyNumber(documentsWithPolicyNumber);
    };

     const addDocumentToNoPolicyNumberGroup = (group, folderPath, doc) => {
            let currentLevel = group.folders;            
            folderPath.forEach((folder, index) => {
                let existing = currentLevel.find(item => item.name === folder);
                if (!existing) {
                    existing = { name: folder, children: [] };
                    currentLevel.push(existing);
                }
                if (index === folderPath.length - 1) {
                    if (!existing.documents) existing.documents = [];
                    existing.documents.push(doc);
                } else {
                    currentLevel = existing.children;
                }
            });
        };


    const sortDocumentsWithPolicyNumber = (documentsWithPolicyNumber: any[]) => {
        const statusOrder = constant.policyStatusOnDocumentTab;
        const policyTypeOrder = constant.policyTypeOrderOnDocumentTab;
        const sortedDocuments = [...documentsWithPolicyNumber];
        sortedDocuments.sort((a, b) => {
            // Sort by policyTermStatus
            const statusA = a.terms[0]?.policyStatus || "";
            const statusB = b.terms[0]?.policyStatus || "";
            const indexA = statusOrder.indexOf(statusA);
            const indexB = statusOrder.indexOf(statusB);

            // If the status is not found in `statusOrder`, assign it a high index to place it at the end
            const statusComparison = (indexA === -1 ? statusOrder.length : indexA) - (indexB === -1 ? statusOrder.length : indexB);

            // If the statuses are different, return the comparison result to sort by status
            if (statusComparison !== 0) {
                return statusComparison;
            }

            // If policyTermStatus is the same, sort by policyTypeId
            const typeA = policyTypeOrder[a.policyTypeId] || 10;
            const typeB = policyTypeOrder[b.policyTypeId] || 10;
            return typeA - typeB;
        });

           // Sort terms in descending order by `polEffDate` under each policy group        
            sortedDocuments.forEach(policy => {
                policy.terms.sort((termA, termB) => {
                    const dateA = new Date(termA.polEffDate).getTime();
                    const dateB = new Date(termB.polEffDate).getTime();
                    return dateB - dateA; // Descending order
                });
            });

        if (sortedDocuments.length > 0) {
            setDocWithPolicies(sortedDocuments);
        }
        else {
            setDocWithPolicies([]);
        }
    };

    const handleUploadClick = async () => {
        // Open modal immediately so async dropdown/doc-type calls do not block user interaction.
        setShowDeleteModal(false);
        setShowUploadModal(true);

        try {
            await FetchCustomerPolicyTermDropdownData();
        }
        catch (error) {
            Logger.logError(error.toString());
        }

        try {
            if (sampleDocumentType.length === 0) {
                await FetchDocumentType();
            }
        }
        catch (error) {
            Logger.logError(error.toString());
        }
    };

    const handleDocumentTypeChange = async (selectedOption) => {
        setDocumentTypeOption(selectedOption.toString());
    }

    const handlePolicyChange = (selectedOption) => {
        setPolicyOption(selectedOption.toString());
        const termsForPolicy = customerDataPolicies
            .filter(term => term.policyNumber === selectedOption.toString())
            .map(term => ({
                value: term.policyId,
                label: `Term: ${moment(term.polEffDate).format("MM/DD/YYYY")} - ${moment(term.polExpDate).format("MM/DD/YYYY")}`
            }));
        setTermArray(termsForPolicy);

    };

    const handleTermChange = (selectedOption) => {
        const option = Array.isArray(selectedOption) ? selectedOption[0] : selectedOption;
        if (!option) return;
        setSelectedTerm(option);

    };

      const handleFolderChange = (selectedOption) => {
        const option = Array.isArray(selectedOption) ? selectedOption[0] : selectedOption;
        if (!option) return;
        setFolderOption(option);
    };

    const handleRefresh = () => {
        try {
            if (showUploadModal) {
                // Keep the Upload popup open on refresh; just reload the Policy dropdown data.
                FetchCustomerPolicyTermDropdownData();
            } else {
                resetPopupState();
            }
            getCustomerPolicyTermDocumentDetails();
        }
        catch (error) {
            Logger.logError(error.toString());
        }
    };
    const getCustomerNumberForUpload = async () => {
        if (custNumber) {
            return custNumber;
        }

        const customerData = await customerDocumentService.getCustomerData(customerId);
        setUploadCustomerSummary(customerData || null);
        return customerData?.custNumber || '';
    };

    const FetchCustomerPolicyTermDropdownData = async () => {
        const customerNumber = await getCustomerNumberForUpload();
        const getCustomerDataQueryModel = {
            AppId: Number(docuMateConstant.cs2RefNum),
            RefrenceNbr: customerNumber,
            type: docuMateConstant.appCustType
        };
        const customerDataResponseDto = await customerDocumentService.GetCustomerData(getCustomerDataQueryModel);
        const policyData = customerDataResponseDto[0]?.customerPolicyData || [];
        setCustomerDataPolicies(policyData);


        const uniquePolicies = Array.from(
            new Map(policyData.map(item => [item.policyNumber, item])).values()
        ).map(policy => ({
            value: policy.policyNumber,
            label: `${policy.policyNumber} ${policy.policyType || ''}`
        }));
        setPolicyArray(uniquePolicies);

        if(uniquePolicies.length === 0){
            setFolderArray([{ value: docuMateConstant.NoPolicyFolderName, label: docuMateConstant.NoPolicyFolderName }]);            
        }

        const filteredTerms = policyData
            .filter(term => term.policyNumber === policyOption)
            .map(term => ({
                value: term.policyId,
                label: `Term: ${moment(term.polEffDate).format("MM/DD/YYYY")} - ${moment(term.polExpDate).format("MM/DD/YYYY")}`
            }));
        setTermArray(filteredTerms);

    };


    const FetchDocumentType = async () => {
        const getDocumentTypeListRequestModel = { AppId: docuMateConstant.cs2RefNum };
        const response = await customerDocumentService.getListOfDocumentType(getDocumentTypeListRequestModel);
        setSampleDocumentType(response);
    };

    const resetPopupState = () => {        
        setShowUploadModal(false);
        setSelectedPolicy('');
        setPolicyOption('');
        setSelectedTerm('');
        setSelectedFile(null);
        setDocumentTypeOption('');
        setFolderOption('');
        setTermArray([]);
        setFileError('');
        setCustomerDataPolicies([]);
        setValidation({
            policy: false,
            term: false,
            documentType: false,
            file: false,
            folder:false,
        });
    }
    const handleCancelUpload = () => {
        resetPopupState();
    };
    const handleUpload = async () => {
         try {
            const isPolicyMissing = isNullOrEmpty(policyOption);
            const isTermMissing = isNullOrEmpty(selectedTerm);
            const isDocumentTypeMissing = isNullOrEmpty(documentTypeOption);
            const isFolderOptionMissing = isNullOrEmpty(folderOption);
            const isFileMissing = !selectedFile;

            let newValidation;
            let hasError = false;

            if (policyArray && policyArray.length > 0) {
                newValidation = {
                    policy: isPolicyMissing,
                    term: isTermMissing,
                    documentType: isDocumentTypeMissing,
                    file: isFileMissing,
                    folder: false,
                };
                hasError = isPolicyMissing || isTermMissing || isDocumentTypeMissing || isFileMissing;
            } else {
                newValidation = {
                    policy: false,
                    term: false,
                    documentType: isDocumentTypeMissing,
                    file: isFileMissing,
                    folder: isFolderOptionMissing,
                };
                hasError = isFolderOptionMissing || isDocumentTypeMissing || isFileMissing;
            }

            setValidation(newValidation);

            if (hasError) {
                setFileError('Please select all required fields.');
                return;
            }

            setFileError('');
            await uploadCustomerDocument();
            resetPopupState();
        }
        catch (error) {
            Logger.logError(error.toString());
        }
    };

    const FetchDocument = async (id: string) => {
        try {
            let documentResponse = await documateServiceObj.getDocument(id);
            setdocViewerId(id);
            setDocNameAPI(documentResponse.filename);
            setDocPDf(documentResponse.blob);
        }
        catch (error) {
            setdocViewerId(null);
            setDocNameAPI('');
            setDocPDf(null);
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    }

    const handleFileClick = (docId) => {
        setDocId(docId);
        setDocViewerOpen(true);
        FetchDocument(docId);
    };

    const deleteDocument = (docId, documentName) => {          
        setDocId(docId); 
        setDocName(documentName);
        setShowUploadModal(false);
        setShowDeleteModal(true);        
    };
    
    const confirmDelete = async (docId, documentName) => {
        try {
            if (docViewerId == docId) {
                setDocViewerOpen(false);
            }
            let resDeleted = await documateServiceObj.deleteDocumentcustomer(docId);
            if (resDeleted) {
                setShowDeleteModal(false);
                
                toast.success(`Document- "${documentName}" deleted successfully!`, {
                position: "top-right",
                });

                setDocId(null); 
                setDocName(null);
                handleRefresh(); 
            }            
        } catch (error) {
            Logger.logError(error.toString());
        }
    };
    
    useEffect(() => {
        if (!showUploadModal) {
            resetPopupState();
        }
    }, [showUploadModal]);

    const uploadCustomerDocument = async () => {
        let userId = userDetails.userContext.id;
        const termObj = customerDataPolicies.find(term => term.policyId === selectedTerm);
        let polEffDate = termObj ? termObj.polEffDate : null;
        let polExpDate = termObj ? termObj.polExpDate : null;

        
        let attributes;
        if(policyArray !== null && policyArray.length> 0)
        {
           attributes = termObj
            ? { term: `${moment(polEffDate).format("MM/DD/YYYY")} to ${moment(polExpDate).format("MM/DD/YYYY")}` }
            : "";
        }
        else
        {
            attributes ={ FolderStructure: folderOption }// here FolderStructure is attribute name in Documate
        }

        attributes = attributes ? JSON.stringify(attributes) : "";

        let payload = {
            appId: Number(docuMateConstant.cs2RefNum),
            fileName: selectedFile.name,
            contentType: selectedFile.type,
            documentTypeId: documentTypeOption,
            indexKey1: custNumber,
            indexKey2: (policyArray !== null && policyArray.length> 0) ? policyOption : "",
            attributes: attributes,
            userId: userId
        };
        if (!selectedFile || selectedFile.type !== "application/pdf") {
            setFileError("Please upload only PDF files");
            setValidation(v => ({ ...v, file: true }));
            return;
        }
        const response = await UploadCustomerDocument(selectedFile, payload);
        if (response && response.docFileId) {

            toast.success(`Document "${response.fileName}" uploaded successfully!`, {
                position: "top-right",
            });
            getCustomerPolicyTermDocumentDetails();
        }
        else {
            toast.error("Failed to upload document. Please try again.", {
                position: "top-right",
            });
        }
    }

    const renderPoliciesPanel = (policies) => (
        <div>
            {(
                policies.map(policy => (
                    <div key={policy.policyNumber}>
                        <div className="policiesList policy-row policy-summary-header d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <span className="cust-doc-policyicon">
                                    <FontAwesomeIcon icon={getPolicyIcon(policy.policyTypeId)} className='custdocpolicyIcons' />
                                </span>
                                <span className="policy-label">
                                    <span className="policy-highlight">
                                        {`${policy.policyNumber} ${policy.policyType || ''}`}
                                    </span>
                                </span>
                            </div>
                            {policy.terms[0] && (
                                 <Badge className={ getStatusBadgeClass(policy.terms[0].calculatedPolTermStatus)  }>
                                    {policy.terms[0].policyStatus}
                                </Badge>

                            )}
                        </div>
                        {policy.terms.map(term => (
                            <div key={term.id} className="cust-doc-termmargin">
                                <div
                                    onClick={() => handleTermToggle(term.id)}
                                    className={`termsList-container term-row ${expandedTerm === term.id ? 'selectedTerm' : ''}`}
                                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                >
                                    <span style={{ marginRight: 8 }}>
                                        {expandedTerm === term.id ? <FaChevronDown /> : <FaChevronRight />}
                                    </span>
                                    <span style={{ marginLeft: 8 }}>
                                        {term.isUnknown?  (
                                            <span>
                                                Term: Unknown
                                            </span>
                                        ) : (
                                            <span>
                                                Term: {term.polEffDate} - {term.polExpDate}
                                            </span>
                                        )}
                                    </span>
                                </div>
                                {expandedTerm === term.id && (
                                    <div className="cust-doc-term-extended">
                                        {term.documents && term.documents.length > 0 ? (
                                            term.documents.map((doc, idx) => (
                                                <div key={doc.docFileId || idx} className="cust-doc-row">
                                                    <div className="cust-doc-column cust-doc-name" onClick={() => handleFileClick(doc.docFileId)}>
                                                        <span className="policydoc-icon">
                                                            <FontAwesomeIcon icon={['fas', 'file-pdf']} />
                                                        </span>
                                                        <strong className="cust-doc-name-truncate" title={doc.documentName}>
                                                            {doc.documentName}
                                                        </strong>
                                                    </div>

                                                    <div className="cust-doc-column cust-doc-type">
                                                        <span className="cust-doc-type-sec">{doc.documentType}</span>
                                                    </div>                                                    
                                                    <div className="cust-doc-column cust-doc-user-date">
                                                        {doc.docUser && (
                                                            <div className="cust-doc-date-sec">
                                                                <strong>{'@' + doc.docUser + ' '}</strong>
                                                                <span className="cust-doc-date">
                                                                    {doc.docDate && <strong>{moment(doc.docDate).format("MM/DD/YYYY")}</strong>}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {isUserPermitToViewDeleteButton &&
                                                        <Icon icon={"trash"} 
                                                        className={`me-1 ${isDeleteDisabledForUserPermission ? 'disabled-icon' : ''}`}
                                                        onClick={() => {
                                                            if (!isDeleteDisabledForUserPermission) {
                                                            deleteDocument(doc.docFileId, doc.documentName);
                                                            }
                                                        }}
                                                        />}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <span style={{ color: '#888' }}>No documents</span>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                ))
            )}
        </div>
    );

    const renderNestedFolders = (folders, level = 0, path = '', expandedFolders, toggleFolder, handleFileClick) => {
        return folders.map((term, index) => {            
            const currentPath = path ? `${path}/${term.name}` : term.name;
            const isExpanded = Array.isArray(expandedFolders) && expandedFolders.includes(currentPath);

            return (
                <div key={currentPath} style={{ marginBottom: '10px', marginLeft: `${level * 20}px` }}>
                    <div
                        onClick={() => toggleFolder(currentPath)}
                        className={`termsList-container term-row ${isExpanded ? 'selectedTerm' : ''}`}
                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                    >
                        <span style={{ marginRight: 8 }}>
                            {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
                        </span>
                        <span style={{ marginLeft: 8 }}>{term.name}</span>
                    </div>

                    {isExpanded && (
                        <div style={{ marginLeft: '20px', marginTop: '4px', display: 'flex', flexDirection: 'column' }}>
                            {term.documents && term.documents.map((doc, docIndex) => (
                                <div key={doc.docFileId || docIndex} className="cust-doc-row">
                                    <div className="cust-doc-column cust-doc-name" onClick={() => handleFileClick(doc.docFileId)}>
                                                        <span className="policydoc-icon">
                                                            <FontAwesomeIcon icon={['fas', 'file-pdf']} />
                                                        </span>
                                                        <strong className="cust-doc-name-truncate" title={doc.documentName}>
                                                            {doc.documentName}
                                                        </strong>
                                    </div>
                                    <div className="cust-doc-column cust-doc-type">
                                                        <span className="cust-doc-type-sec">{doc.documentType}</span>
                                    </div>  
                                    <div className="cust-doc-column cust-doc-user-date">
                                                        {doc.docUser && (
                                                            <div className="cust-doc-date-sec">
                                                                <strong>{'@' + doc.docUser + ' '}</strong>
                                                                <span className="cust-doc-date">
                                                                    {doc.docDate && <strong>{moment(doc.docDate).format("MM/DD/YYYY")}</strong>}
                                                                </span>
                                                            </div>
                                                        )}
                                     </div>
                                    <div>
                                        {isUserPermitToViewDeleteButton &&
                                            <Icon icon={"trash"} 
                                                className={`me-1 ${isDeleteDisabledForUserPermission ? 'disabled-icon' : ''}`}
                                                onClick={() => {
                                                    if (!isDeleteDisabledForUserPermission) {
                                                        deleteDocument(doc.docFileId, doc.documentName);
                                                    }
                                                }}
                                            />
                                        }
                                    </div>
                                </div>
                            ))}

                            {term.children && term.children.length > 0 &&
                                renderNestedFolders(term.children, level + 1, currentPath, expandedFolders, toggleFolder, handleFileClick)
                            }
                        </div>
                    )}
                </div>
            );
        });
    };

    const renderdocumentsWithoutPolicyNumber = (policies) => (
    <div>
        {policies.map((policy, index) => {          
            return (
                <div key={index}>
                    
                    {renderNestedFolders(policy.folders, 0, '', expandedFolders, toggleFolder, handleFileClick)}
                </div>
            );        
        })}
    </div>
);

    const renderUploadModalBody = () => (
        <div className="cust-uploaddiv">
           {(policyArray !== null && policyArray.length > 0 ) ? (
            <><Row className="rowmargin">
                    <Column lg={12} md={12}>
                        <Select
                            id="ddlPolicy"
                            controlId="ddlPolicy"
                            isRequired={true}
                            label={documateLabel.INDEXING_PROCESSING_LABELS.policy}
                            className={`mb-3${validation.policy ? ' cust-doc-input-error' : ''}`}
                            options={policyArray}
                            onChange={handlePolicyChange}
                            defaultSelected={policyArray?.filter(({ value }) => value === policyOption)}
                            placeholder="Select Policy"
                            tabIndex={20}
                            multiple={false} />
                    </Column>
                </Row>
                <Row className="rowmargin">
                        <Column lg={12} md={12}>
                            <Select
                                id="ddlTerm"
                                controlId="ddlTerm"
                                isRequired={true}
                                label={documateLabel.INDEXING_PROCESSING_LABELS.term}
                                className={`mb-3${validation.term ? ' cust-doc-input-error' : ''}`}
                                options={termArray}
                                onChange={handleTermChange}
                                defaultSelected={termArray?.filter(({ value }) => value === selectedTerm)}
                                placeholder="Select Term"
                                tabIndex={21} />
                        </Column>
                </Row>
            </>
        ): <Row className="rowmargin">
                <Column lg={12} md={12}>
                    <Select
                        id="ddlFolder"
                        controlId="ddlFolder"
                        isRequired={true}
                        label={documateLabel.INDEXING_PROCESSING_LABELS.folder}
                        className={`mb-3${validation.policy ? ' cust-doc-input-error' : ''}`}
                        options={folderArray}
                        onChange={handleFolderChange}
                        defaultSelected={
                            folderArray?.filter(({ value }) => value === folderOption)
                        }
                        placeholder="Select Folder"
                        tabIndex={20}
                        multiple={false}
                    />
                </Column>
            </Row>}
            <Row className="rowmargin">
                <Column lg={12} md={12}>
                    <Select
                        id="ddlDocumentType"
                        label={documateLabel.INDEXING_PROCESSING_LABELS.documentType}
                        controlId="ddlDocumentType"
                        isRequired={true}
                        className={`mb-3${validation.documentType ? ' cust-doc-input-error' : ''}`}
                        options={sampleDocumentType}
                        onChange={
                            (value) => handleDocumentTypeChange(value)
                        }
                        defaultSelected={
                            sampleDocumentType?.filter(({ value }) => value === documentTypeOption)
                        }
                        placeholder="Choose Type..."
                        tabIndex={22}
                    />
                </Column>
            </Row>
            <Row className="rowmargin">
                <Column lg={12} md={12}>
                    <div
                        className={`custom-file-uploader${validation.file ? ' input-error' : ''}`}
                        onClick={() => document.getElementById('fileInput')?.click()}
                        onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = '#007bff'; }}
                        onDragLeave={e => { e.preventDefault(); e.currentTarget.style.borderColor = '#b3b3b3'; }}
                        onDrop={e => {
                            e.preventDefault();
                            e.currentTarget.style.borderColor = '#b3b3b3';
                            const file = e.dataTransfer.files?.[0] || null;
                            if (file && file.type !== "application/pdf") {
                                setFileError("Please upload only PDF files");
                                setSelectedFile(null);
                                setValidation(v => ({ ...v, file: true }));
                            } else {
                                setFileError('');
                                setSelectedFile(file);
                                setValidation(v => ({ ...v, file: false }));
                            }
                        }}
                    >
                        <input
                            id="fileInput"
                            required={true}
                            type="file"
                            accept="application/pdf"
                            style={{ display: 'none' }}
                            onChange={e => {
                                const file = e.target.files?.[0] || null;
                                if (file && file.type !== "application/pdf") {
                                    setFileError("Please upload only PDF files");
                                    setSelectedFile(null);
                                    setValidation(v => ({ ...v, file: true }));
                                } else {
                                    setFileError('');
                                    setSelectedFile(file);
                                    setValidation(v => ({ ...v, file: false }));
                                }
                            }}
                        />
                        <div className="cust-doc-file-icon">
                            <FontAwesomeIcon icon="file-upload" />
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 500, color: '#333', marginBottom: 2, marginTop: 20 }}>
                                {selectedFile
                                    ? <>
                                        <FontAwesomeIcon icon="file-pdf" className="me-2" style={{ color: '#d9534f' }} />
                                        {selectedFile.name}
                                    </>
                                    : "Drag & drop a PDF file here, or click to select"}
                            </div>
                            <div
                                className="pdf-info-message"
                                style={{ marginBottom: fileError ? 8 : 0 }}
                            >
                                Only PDF files are allowed.
                            </div>
                            {fileError && (
                                <div style={{ color: "red", fontSize: "0.9em", marginTop: 8, fontWeight: 500 }}>
                                    {fileError}
                                </div>
                            )}
                        </div>
                    </div>
                </Column>
            </Row>
            <Row className="rowmargin" style={{ marginTop: '50px', marginBottom: '10px' }}>
                <Column lg={6} md={6} className="text-start">
                    <Button
                        outlined
                        className="btn btn-outline-second"
                        title="Cancel upload"
                        type="button"
                        onClick={handleCancelUpload}
                    >
                        <FontAwesomeIcon icon="cancel" className="me-2" />
                        {label.CANCEL.toLocaleUpperCase()}
                    </Button>
                </Column>
                <Column lg={6} md={6} className="text-end">
                    <Button
                        className="btn btn-primary"
                        title="Upload document"
                        type="button"
                        onClick={handleUpload}
                    >
                        <FontAwesomeIcon icon="cloud-upload-alt" className="me-2" />
                        {label.UPLOAD.toLocaleUpperCase()}
                    </Button>
                </Column>
            </Row>
        </div>
    );
    return (
        <Container fluid>
            <Row>
                <Column lg={12}>
                    <Row>
                        <Column lg={6} md={6} style={{ boxSizing: "border-box", borderRight: '2px solid grey' }}>
                            <Row>
                                <Column lg={12} md={12} className="col-section-header">
                                    <div className="centered-row">
                                        <Button
                                            outlined
                                            className="btn btn-outline-second"
                                            color="info"
                                            tabIndex={67}
                                            id="btnRefresh"
                                            onClick={handleRefresh}
                                        >
                                            <Icon icon="refresh" className="me-1" />
                                            {label.REFRESH.toLocaleUpperCase()}
                                        </Button>
                                        {isUserPermitToViewUpploadButton &&
                                            <Button
                                                className="btn btn-primary"
                                                tabIndex={68}
                                                id="btnUpload"
                                                onClick={handleUploadClick}
                                                disabled={isUploadDisabledForUserPermission}
                                            >
                                                <FontAwesomeIcon icon="file-upload" className="me-1" />
                                                {label.UPLOAD.toLocaleUpperCase()}
                                            </Button>
                                        }
                                    </div>
                                </Column>
                            </Row>
                            <Row>
                                <Column lg={12} md={12} className="col-section-header">
                                    <div className="custdoc-panel-overflow-scroll">
                                    <Panel className="">
                                        {(docWithPolicies.length === 0 && docWithOutPolicies.length === 0) ? (
                                            <div className="message-container">{screenMessage}</div>
                                        ) : (
                                            <>
                                                {docWithPolicies.length > 0 && (
                                                    <div>{renderPoliciesPanel(docWithPolicies)}</div>
                                                )}
                                               {[docuMateConstant.NoPolicyFolderName, "OTHER"].map(type => {
                                                    const filtered = docWithOutPolicies.filter(p => p.type === (type === docuMateConstant.NoPolicyFolderName ? docuMateConstant.NoPolicyFolderName : "OTHER"));
                                                    if (filtered.length === 0) return null;

                                                    return (
                                                        <div key={type}>
                                                            <div className="policiesList policy-row policy-summary-header d-flex align-items-center justify-content-between">
                                                                <div className="d-flex align-items-center">
                                                                    <span className="cust-doc-policyicon">
                                                                        <Icon icon="folderOpen" className='custdocIcons' />
                                                                    </span>
                                                                    <span className="policy-label">
                                                                        <span className="policy-highlight">
                                                                            {type === docuMateConstant.NoPolicyFolderName ? docuMateConstant.NoPolicyFolderName : "Migrated Documents"}
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {renderdocumentsWithoutPolicyNumber(filtered)}
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </Panel>
                                    </div>
                                </Column>
                            </Row>
                        </Column>
                        <Column lg={6} md={6} >
                            <Row>
                                <Column lg={12} md={12} className="col-section-header">
                                    {docViewerOpen && <div className="custdoc-viewer-scroll">
                                        <DocViewer document={docPdf} scanId={docNameAPI} />
                                    </div>}
                                </Column>
                            </Row>
                        </Column>
                    </Row>
                </Column>
            </Row>
            <ConfirmModal
                modaltitle={`Upload Files to ${custName ? ` ${custName}` : ''}`}                              
                showConfirmation={showUploadModal}
                setConfirmation={setShowUploadModal}                
                body={renderUploadModalBody()}
                hideButtons={true}
            />
            
            <ConfirmModal
                modaltitle="Confirm Delete"
                showConfirmation={showDeleteModal}
                setConfirmation={(val) => {
                    setShowDeleteModal(val);
                    if (!val) setDocId(null); // optional cleanup
                }}
                body={
                    <div>
                        <p>Are you sure you want to Delete <strong>{docName}</strong> ?</p>
                        <div className="text-end mt-3">                            
                            <Button 
                                className="btn btn-danger me-2"
                                title="Delete"                                
                                onClick={() => confirmDelete(docId, docName )}>
                                <FontAwesomeIcon icon="trash" className="me-2" />
                                {label.DELETE.toLocaleUpperCase()}
                            </Button>                                                      
                            <Button 
                                outlined                               
                                className="btn btn-outline-second"
                                title="Cancel"
                                type="button"                        
                                onClick={() => setShowDeleteModal(false)}>
                                <FontAwesomeIcon icon="cancel" className="me-2" />
                                {label.CANCEL.toLocaleUpperCase()}
                            </Button>
                        </div>
                    </div>
                }
                hideButtons={true}
            />
        </Container>
    );
};

export default CustomerDocument;